import type { TokenType } from "@multiversx/sdk-dapp/types/tokens.types";
import type { AccountType } from "@multiversx/sdk-dapp/types";
import type { EconomicsInfoType } from "@multiversx/sdk-dapp/apiCalls";
import BigNumber from "bignumber.js";

import { EGLD, EGLD_DECIMALS } from "@/config";

import { chainIdByEnvironment } from "@multiversx/sdk-dapp/constants/network";

import { environment } from "@/config";

export const getChainId = () => {
  return chainIdByEnvironment[environment];
};

export const getMxTokenImg = (identifier?: string) => {
  if (!identifier) return "/images/icons/unknown-esdt.png";

  const chain = getChainId();
  if (identifier === EGLD)
    return "https://raw.githubusercontent.com/multiversx/mx-assets/master/identities/multiversx/logo.png";

  if (chain === "D") {
    return `https://raw.githubusercontent.com/multiversx/mx-assets/master/devnet/tokens/${identifier}/logo.png`;
  }

  return `https://raw.githubusercontent.com/multiversx/mx-assets/master/tokens/${identifier}/logo.png`;
};

export const accountToEgldToken = (
  account: AccountType,
  economics: EconomicsInfoType
): TokenType => {
  const denominatedBalance = BigNumber(account.balance)
    .dividedBy(10 ** EGLD_DECIMALS)
    .toString();
  return {
    identifier: EGLD,
    ticker: EGLD,
    name: "MultiversX",
    balance: account.balance,
    decimals: EGLD_DECIMALS,
    owner: "",
    minted: "",
    burnt: "",
    supply: economics.totalSupply,
    circulatingSupply: economics.totalSupply,
    canBurn: false,
    canChangeOwner: false,
    canFreeze: false,
    canMint: false,
    canPause: false,
    canUpgrade: false,
    canWipe: false,
    isPaused: false,
    transactions: 0,
    accounts: 0,
    price: economics.price,
    marketCap: economics.marketCap,
    valueUsd: economics.price * Number(denominatedBalance),
  };
};
